var watchlistList = {
	caption: "Watchlist list",
	name: "Name",
	numberOfPositions: "Positions",
	actions: "Actions",
	createWatchlistAction: "Add Watchlist",
	editWatchlistAction: "Edit Watchlist",
	deleteWatchlistAction: "Delete Watchlist",
	noWatchlist: {
		title: "Info",
		message: "No watchlist has been created yet. Please click on the Add watchlist button and fill out the form to create a watchlist"
	},
	showActions: "Show actions"
};
var en = {
	watchlistList: watchlistList
};

export { en as default, watchlistList };
